import React, { useEffect, useState } from "react";
import { PenLine, Loader2 } from "lucide-react";
import api from "../../lib/api";

// Signature enregistrée sur la fiche du propriétaire du bien → signer en un clic.
export function SavedSignatureButton({ propertyId, propertyName, onUse, busy }) {
  const [sig, setSig] = useState(null);
  useEffect(() => {
    if (!propertyId && !propertyName) return;
    const q = new URLSearchParams({ property_id: propertyId || "", property_name: propertyName || "" });
    api.get(`/owners/saved-signature?${q}`).then((r) => setSig(r.data.available ? r.data : null)).catch(() => {});
  }, [propertyId, propertyName]);
  if (!sig) return null;
  return (
    <div className="mb-4 p-3 rounded-2xl bg-brand-lime/15 border border-brand-lime/50 flex flex-wrap items-center gap-3" data-testid="saved-signature-box">
      <img src={sig.data_url} alt="Signature enregistrée" className="h-12 max-w-[120px] object-contain bg-white rounded-lg p-1" />
      <div className="flex-1 min-w-0">
        <p className="text-xs text-brand-green/60">Signature enregistrée de</p>
        <p className="text-sm font-semibold text-brand-greenDeep break-words">{sig.name}</p>
      </div>
      <button type="button" onClick={() => onUse(sig.name, sig.data_url)} disabled={busy} className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white text-xs font-semibold disabled:opacity-60" data-testid="use-saved-signature-btn">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <PenLine className="w-3.5 h-3.5" />} Signer en un clic
      </button>
    </div>
  );
}
